<div class="appContentsContainer">
  <form
    [formGroup]="datosAccesorios"
    (ngSubmit)="onImport()"
    class="formGroup container halfForm wrapHalfRows"
  >
    <div class="collapseButtonContainer">
      <div class="pageTitle collapsibleTitle">
        <div class="pageTitle">Importar datos accesorios</div>
      </div>
    </div>

    <div class="halfGroup">
      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel"><label>Fecha de última carga </label></div>
          </div>
          <div class="inputContainer">
            <input
              id="glValor"
              type="text"
              formControlName="glValor"
              [readonly]="true"
            />
          </div>
        </div>
      </div>
      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label>Fichero</label>
            </div>
          </div>
          <div class="inputContainer">
            <div
              class="dummyButtonContainer"
              style="cursor: pointer !important"
            >
              <div class="dummyButton">
                <em class="fas fa-file-upload"></em>
              </div>
              <div class="dummyFileInput" style="min-height: 20px !important">
                <div
                  class="dummyFileName adjustText"
                  style="max-height: 20px !important"
                >
                  {{ files.file }}
                </div>
              </div>
            </div>
            <input
              class="inputFile detallesEspecificosinputFile noselect"
              type="file"
              style="cursor: pointer !important"
              (change)="handleFileInput($event)"
            />
          </div>
        </div>
      </div>
      <div class="formGroupButtons detalleFormGroupButtonsFooter">
        <div class="formButton">
          <button
            class="submitButton"
            type="button"
            (click)="goPredefinedMailBox()"
          >
            <em class="fas fa-times fa-2x backButtonAlign"></em>
          </button>
        </div>

        <div class="middleButtonAceptarContainer notFullWidth">
          <div class="middleButtonAceptar formButton">
            <button class="submitButton" type="submit">Importar</button>
          </div>
          <div class="middleButtonAceptar formButton">
            <button class="submitButton" type="button" (click)="onRevert()">
              Revertir
            </button>
          </div>
          <div class="middleButtonAceptar formButton">
            <button class="submitButton" type="button" (click)="onDownload()">
              Descarga
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
  <swal
    #uploadSwal
    html="{{ mensajeSwalPopup }}"
    icon="{{ iconSwalPopup }}"
    [focusCancel]="true"
    (confirm)="resetMensajeBackRevertir()"
    [swalOptions]="{
      allowEscapeKey: false,
      allowOutsideClick: false
    }"
  >
  </swal>
</div>
